module.exports = __webpack_public_path__ + "img/team_photo_3.37d43d8f.png";